import { render, staticRenderFns } from "./RegulationPage.vue?vue&type=template&id=2330ca41&scoped=true"
import script from "./RegulationPage.vue?vue&type=script&lang=js"
export * from "./RegulationPage.vue?vue&type=script&lang=js"
import style0 from "./RegulationPage.vue?vue&type=style&index=0&id=2330ca41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330ca41",
  null
  
)

export default component.exports